import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { API } from '../../lib/api';

/**
 * Výběr oblasti (kraje, státu, prefektury…) v rámci země.
 *
 * Ne každá země oblasti má a u některých je Bloom zatím nezná. Když žádné
 * nejsou, komponenta se prostě nevykreslí – prázdná nabídka „vyberte oblast",
 * ve které nic není, je horší než žádná.
 */
export default function RegionSelect({ countryIso2, hodnota, onChange, label = 'Oblast' }) {
  const [oblasti, setOblasti] = useState([]);
  const [nacita, setNacita] = useState(false);

  useEffect(() => {
    if (!countryIso2) { setOblasti([]); return; }
    let zivy = true;
    setNacita(true);
    // Bereme to přes kód země, ne slug – formuláře pracují s kódem.
    axios.get(`${API}/geo/countries/${countryIso2}/regions`)
      .then((r) => { if (zivy) setOblasti(r.data); })
      .catch(() => { if (zivy) setOblasti([]); })
      .finally(() => { if (zivy) setNacita(false); });
    return () => { zivy = false; };
  }, [countryIso2]);

  if (!countryIso2 || (!nacita && oblasti.length === 0)) return null;

  return (
    <div>
      <label className="text-sm text-bloom-text">{label}</label>
      <select
        value={hodnota || ''}
        onChange={(e) => onChange(e.target.value)}
        disabled={nacita}
        className="mt-1 h-10 w-full rounded-md border border-input bg-background px-3 text-sm text-bloom-text"
        data-testid="region-select"
      >
        <option value="">{t(nacita ? 'obecne.nacitam' : 'obecne.nezadano')}</option>
        {oblasti.map((o) => (
          <option key={o.id} value={o.id}>{dvojjazycne(o.name_cs, o.name_en) || o.name_cs || o.name_en}</option>
        ))}
      </select>
    </div>
  );
}
